import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useContext } from 'react';
import { AuthContext, AuthProvider } from './context/AuthContext';
import Shiba from './pages/Shiba';
import Dart from './pages/Dart';
import SubjectShiba from './pages/SubjectShiba';
import SubjectDart from './pages/SubjectDart';
import NotFoundPage from './pages/NotFoundPage'; // 404 ページ（必要なら作る）
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import UserPage from './pages/UserPage';
import Previous from './pages/Previous';
import Yosou from './pages/Yosou';
import YosouRegist from './pages/YosouRegist';
import RaceList from './pages/RaceList';
import OldRaceList from './pages/OldModelRaceList';
import NewRaceList from './pages/NewModelRaceList';
import ChiririModelRaceList from './pages/ChiririModelRaceList';
import Top1ModelPage from './pages/Top1ModelPage';
import NarModelRaceList from './pages/NarModelRaceList';
import KeirinModelRaceList from './pages/KeirinModelRaceList';
import ChiririModelKaimePage from './pages/ChiririModelKaimePage';
import YoutubeNewModelRaceList from './pages/YoutubeNewModelRaceList';
import LpPage from './pages/LpPage';
import NotePostsPage from './pages/NotePostsPage';
// **認証が必要なページ（未ログイン時は `/login` にリダイレクト）**
const PrivateRoute = ({ element }) => {
  const { isAuthenticated } = useContext(AuthContext);

  if (isAuthenticated === null) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  return element;
};
// **ログインページへのアクセス制御（ログイン済みならレース一覧へ）**
const PublicRoute = ({ element }) => {
  const { isAuthenticated } = useContext(AuthContext);
  return isAuthenticated ? <Navigate to="/chiriri_model_race_list" replace /> : element;
};

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<PublicRoute element={<LoginPage />} />} />
          <Route path="/usersignupsecret" element={<PublicRoute element={<SignupPage />} />} />
          <Route path="/lp" element={<LpPage />} />
          {/* <Route element={<Layout />}> */}
          <Route
            path="/"
            element={
              <PrivateRoute element={<Navigate to="/chiriri_model_race_list" replace />} />
            }
          />
          {/* <Route path="/user" element={<PrivateRoute element={<UserPage />} requiredPermission="admin"/>} /> */}
          <Route
            path="/user"
            element={<PrivateRoute element={<UserPage />} requiredPermission="admin" />}
          />
          <Route path="/subject_shiba" element={<PrivateRoute element={<SubjectShiba />} />} />
          <Route path="/subject_all" element={<PrivateRoute element={<SubjectDart />} />} />
          <Route path="/shiba" element={<PrivateRoute element={<Shiba />} />} />
          <Route path="/dart" element={<PrivateRoute element={<Dart />} />} />
          <Route path="/yosou" element={<PrivateRoute element={<Yosou />} />} />
          <Route path="/previous" element={<PrivateRoute element={<Previous />} />} />
          <Route path="/yosou_regist" element={<PrivateRoute element={<YosouRegist />} />} />
          <Route path="/race_list" element={<PrivateRoute element={<RaceList />} />} />
          <Route path="/old_model_race_list" element={<PrivateRoute element={<OldRaceList />} />} />
          <Route path="/new_model_race_list" element={<PrivateRoute element={<NewRaceList />} />} />
          <Route path="/chiriri_model_race_list" element={<PrivateRoute element={<ChiririModelRaceList />} />} />
          {/* 中央新版（V14C）はクローズ済み。旧URLは中央競馬ページへリダイレクト */}
          <Route path="/ana_model_race_list" element={<Navigate to="/chiriri_model_race_list" replace />} />
          <Route path="/ana_new_model_race_list" element={<Navigate to="/chiriri_model_race_list" replace />} />
          <Route path="/top1_model_race_list" element={<PrivateRoute element={<Top1ModelPage />} />} />
          <Route path="/nar_model_race_list" element={<PrivateRoute element={<NarModelRaceList />} />} />
          <Route path="/keirin_model_race_list" element={<PrivateRoute element={<KeirinModelRaceList />} />} />
          <Route path="/note_posts" element={<PrivateRoute element={<NotePostsPage />} />} />
          <Route path="/chiriri_model_kaime_test" element={<PrivateRoute element={<ChiririModelKaimePage />} />} />
          <Route path="/youtube_race" element={<YoutubeNewModelRaceList />} />
          <Route path="*" element={<NotFoundPage />} /> {/* 404 ページ */}
          {/* </Route> */}
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
